export default "__VITE_ASSET__BS3b7vzQ__"